import script from "./Icon.vue?vue&type=script&lang=ts&setup=true"
export * from "./Icon.vue?vue&type=script&lang=ts&setup=true"

import "./Icon.vue?vue&type=style&index=0&id=ef3f5d54&lang=postcss"
import "./Icon.vue?vue&type=style&index=1&id=ef3f5d54&scoped=true&lang=postcss"

import exportComponent from "/Users/benedge/Projects/KPMG-30-Voices-FS-2022/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef3f5d54"]])

export default __exports__